import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#trimLeadingText();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Drop the anonymous space/newline Liquid leaves before the first word.
   * In RTL that shows up as a gap before the first Arabic character.
   */
  #trimLeadingText() {
    const trimNode = (node) => {
      if (!node) return;
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = node.textContent.replace(/^[\s\u00a0]+/, '');
        if (!node.textContent) node.remove();
        return;
      }
      if (node.nodeType === Node.ELEMENT_NODE && node.firstChild) {
        trimNode(node.firstChild);
      }
    };

    trimNode(this.firstChild);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
